import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {numberFormat} from "@pg-mono/string-utils";

import type {IRPStore} from "../../../app/rp_reducer";
import {useShouldShowPrice} from "../../../hooks/use_should_show_price";
import {getCurrency} from "../../../utils/get_currency";
import type {IOfferDetail} from "../../types/IOfferDetail";

interface IProps {
    offer: IOfferDetail;
}

export const OfferHighlightedPrice = (props: IProps) => {
    const shouldShowPrice = useShouldShowPrice({
        offerPriceVisibility: props.offer.configuration.price_visibility,
        vendorPriceVisibility: props.offer.vendor.configuration.price_visibility,
        vendorId: props.offer.vendor.id
    });

    const lowestPriceProperty = useSelector((state: IRPStore) => state.offerDetail.lowestPriceProperty);

    if (!shouldShowPrice) {
        return null;
    }

    if (!lowestPriceProperty || (lowestPriceProperty && lowestPriceProperty.price === null)) {
        return null;
    }

    const currency = getCurrency({currency: props.offer.currency});

    return (
        <div className={price}>
            <Text as="span" variant="headline_2">
                od {numberFormat(lowestPriceProperty.price as number)}&nbsp;
            </Text>
            <Text as="span" variant="headline_6">
                {currency}
            </Text>
        </div>
    );
};

const price = css({
    backgroundColor: "var(--colors-primary)",
    paddingX: 1,
    paddingY: 0.5,
    display: "inline-flex",
    alignItems: "baseline"
});
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {numberFormat} from "@pg-mono/string-utils";

import type {IRPStore} from "../../../app/rp_reducer";
import {useShouldShowPrice} from "../../../hooks/use_should_show_price";
import {getCurrency} from "../../../utils/get_currency";
import type {IOfferDetail} from "../../types/IOfferDetail";

interface IProps {
    offer: IOfferDetail;
}

export const OfferHighlightedPrice = (props: IProps) => {
    const shouldShowPrice = useShouldShowPrice({
        offerPriceVisibility: props.offer.configuration.price_visibility,
        vendorPriceVisibility: props.offer.vendor.configuration.price_visibility,
        vendorId: props.offer.vendor.id
    });

    const lowestPriceProperty = useSelector((state: IRPStore) => state.offerDetail.lowestPriceProperty);

    if (!shouldShowPrice) {
        return null;
    }

    if (!lowestPriceProperty || (lowestPriceProperty && lowestPriceProperty.price === null)) {
        return null;
    }

    const currency = getCurrency({currency: props.offer.currency});

    return (
        <div className={price}>
            <Text as="span" variant="headline_2">
                od {numberFormat(lowestPriceProperty.price as number)}&nbsp;
            </Text>
            <Text as="span" variant="headline_6">
                {currency}
            </Text>
        </div>
    );
};

const price = css({
    backgroundColor: "var(--colors-primary)",
    paddingX: 1,
    paddingY: 0.5,
    display: "inline-flex",
    alignItems: "baseline"
});
